import React from 'react';
import PropTypes from 'prop-types';
import ChipSelection from './chip-selection';

const homeOwnershipOptions = [
  {
    label: 'Own',
    value: 'own'
  },
  {
    label: 'Rent',
    value: 'rent'
  }
];

const HomeOwnershipChipSelection = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <ChipSelection
      name='homeOwnerStatus'
      header='home ownership status'
      options={homeOwnershipOptions}
      data-cv-test="homeOwnerStatus"
      {...props}
      data-cv-test-override={dataCvTest || 'homeOwnerStatus'}
    />
  );
};

HomeOwnershipChipSelection.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

HomeOwnershipChipSelection.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default HomeOwnershipChipSelection;
